var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Chip, ChipAction, Menu, Sidebar, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Form, Formik } from 'formik';
import { useCategories } from './useCategories';
import { useUpdateCategory } from './useUpdateCategory';
import { useDocumentMetadata } from '../DocumentMetadataProvider';
import { SingleSelectList } from '../MetadataField/MetadataForm/SingleSelectList';
export function TemplateCategory() {
    const { data, documentId } = useDocumentMetadata();
    const { categories } = useCategories();
    const { addToast } = useToast();
    const { mutation } = useUpdateCategory(documentId);
    const { systemData } = data;
    const { category, categoryId } = systemData;
    const fallback = t({
        message: 'No category',
        comment: 'Metadata: Fallback for template category',
    });
    const handleOnSubmit = (formData) => __awaiter(this, void 0, void 0, function* () {
        const { value } = formData;
        try {
            yield mutation(value);
            addToast({
                title: t({ message: 'Template category updated', comment: 'Metadata: Category updated' }),
                appearance: 'success',
            });
        }
        catch (_a) {
            addToast({
                title: t({ message: 'An error occurred', comment: 'Metadata: Category update failed' }),
                appearance: 'danger',
            });
        }
    });
    return (<Sidebar.DefinitionItem term={t({ message: 'Template category', comment: 'Metadata: Label for template category' })}>
      <Sidebar.Definition>
        <Chip size="small" secondary={category || fallback} appearance="secondary" action={<Menu.Root target={<ChipAction>
                  <Falcon icon="ellipsis-vertical"/>
                </ChipAction>}>
              <Formik onSubmit={handleOnSubmit} initialValues={{ value: categoryId }}>
                <Form style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                  <SingleSelectList data={categories}/>
                </Form>
              </Formik>
            </Menu.Root>}/>
      </Sidebar.Definition>
    </Sidebar.DefinitionItem>);
}
